import { ChoiceButton } from "@components/buttons"
import { forwardRef, PropsWithChildren, useCallback } from "react"
import { useWindowLayout } from "~/hooks/use-window-layout"

import { Wrapper, Question, Options, Shadow } from "./select-picture-screen.styles"

export interface ISelectPictureScreenProps {
	label: string
	options: string[]
	attachments: string[]
	onNext: (s: any) => void
}

export const SelectPictureScreen = forwardRef<
	unknown,
	PropsWithChildren<ISelectPictureScreenProps & JSX.IntrinsicElements["div"]>
>(({ onNext, ...rest }, ref: any) => {
	const size = useWindowLayout()
	const handleClick = useCallback(
		(option: any) => {
			return () => {
				onNext({ value: [option] })
			}
		},
		[onNext]
	)

	return (
		<Wrapper ref={ref} size={size}>
			<Question size={size}>{rest.label}</Question>
			<Options>
				{rest.options.map((option, index) => (
					<ChoiceButton key={option} size={size} onClick={handleClick(option)} picture={rest.attachments[index]}>
						{option}
					</ChoiceButton>
				))}
				<Shadow />
			</Options>
		</Wrapper>
	)
})
